import React from 'react';
import { Container } from 'reactstrap';

import AppLayoutPage from './AppLayoutPage';
import AppLayoutShowcase from './AppLayoutShowcase';

const LayoutPage = () => {
  return (
    <Container>
      <AppLayoutShowcase />
      <AppLayoutPage />
    </Container>
  );
};

export default LayoutPage;
